import Result from "slotworks/model/gameplay/records/results/result";

export class JackpotTriggertrailResult extends Result {
    public jackpots: number[];
    public triggerTrailState: number;
}
